<div [formGroup]="parentForm">
  <p-datepicker
    #myStartCalendar
    [id]="id"
    [name]="name"
    [formControlName]="control"
    (onSelect)="selectedDate($event)"
    [styleClass]="class"
    [inputStyleClass]="inputStyleClass"
    [disabled]="disabled"
    [required]="required"
    [placeholder]="placeholder"
    [showIcon]="showIcon"
    [showTime]="showTime"
    [timeOnly]="timeOnly"
    [hideOnDateTimeSelect]="hideOnDateTimeSelect"
    [panelStyleClass]="panelStyleClass"
    [readonlyInput]="readonlyInput"
    [dateFormat]="dateFormat"
    [selectionMode]="selectionMode"
    [view]="view"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [baseZIndex]="baseZIndex"
    appendTo="body"
    >
    @if (isFooter) {
      <ng-template pTemplate="footer">
        <div class="absolute inset-x-0 m-2 pt-1 border-t-2">
          <div class="float-left ml-3 w-20">
            <gdx-button
              [id]="'btn_filter-apply'"
              [type]="btnType.reset"
              [text]="clear"
              (clicked)="clearDateRange()"
              >
            </gdx-button>
          </div>
          <div class="float-right mr-3 w-20">
            <gdx-button
              [id]="'btn_filter-apply'"
              [type]="btnType.success"
              [text]="apply"
              (clicked)="applyDateRange()"
              >
            </gdx-button>
          </div></div>
      </ng-template>
      }
    </p-datepicker>
  </div>

